var LoadingLayer = $.extend({/* LoadingLayer */}, BaseComponent, {

	componentSelector: '.loading-layer',

	show: function() {
		$(this.componentSelector).removeClass('hide');
		$(this.componentSelector).fadeToggle(500);
	},

	hide: function() {
		$(this.componentSelector).fadeToggle(500, (function() {
			$(this.componentSelector).addClass('hide');
		}).bind(this));
	},

	firstDOMLoad: function() {
		$(this.componentSelector).fadeToggle(750, (function() {
			$(this.componentSelector).removeClass('dom-loading').addClass('hide');
		}).bind(this));
	}
})